export class RequestResult<T> {
  constructor(
    public readonly error: string | any,
    public readonly data: T,
    public readonly statusCode: number,
  ) {}
  public isPositive(): boolean {
    return this.statusCode >= 200 && this.statusCode <= 299;
  }
  public toString(): string {
    return `Data: ${JSON.stringify(this.data)}\nError : ${this.error}\n Status code : ${this.statusCode}`;
  }
  // returns if the status code is 404 not found
  public isNotFound(): boolean {
    return this.statusCode === 404;
  }
  // returns if the status code is 409 conflict
  public isConflict(): boolean {
    return this.statusCode === 409;
  }
  // returns if the status code is 400 bad request
  public isBadRequest(): boolean {
    return this.statusCode === 400;
  }
  // returns if the status code is 401 unauthorized
  public isUnauthorized(): boolean {
    return this.statusCode === 401;
  }
  // returns if the status code is 403 forbidden.
  public isForbidden(): boolean {
    return this.statusCode === 403;
  }
}
